<ng-container *ngIf="placemarkImage; else notSelected">
  <button class="info-card-btn_img" type="button" mat-button (click)="selectInfoCardImages()"
          matTooltip="Change infocard image">
    {{'sources.configuration.InfoCardImage.Title' | translate}}
    <img src="{{ infoCardImageUrl }}" alt=""/>
  </button>
  <button class="btn-clear" type="button" mat-icon-button matTooltip="Clear"
          (click)="resetInfoCardImage()">
    <mat-icon>close</mat-icon>
  </button>
</ng-container>

<ng-template #notSelected>
  <button
    type="button"
    class="info-card-btn_img"
    mat-button
    (click)="selectInfoCardImages()"
    matTooltip="{{ 'configurations-fields.tooltips.InfocardImage' | translate }}"
  >
    {{ 'configurations-fields.InfocardImage' | translate }}
  </button>
</ng-template>
